import {z} from 'zod';

export const UserPropertyNameSchema = z
  .string()
  .min(1)
  .max(50)
  .regex(/^[a-zA-Z0-9_\s.-]+$/u);

export const UserPropertyDataTypeSchema = z.enum(['string', 'number', 'boolean', 'date']);
export type UserPropertyDataType = z.infer<typeof UserPropertyDataTypeSchema>;

export type UserPropertyValue = string | number | boolean | Date;
